import * as React from 'react';
import {CSSProperties} from 'react';
import FormItem from 'antd/lib/form/FormItem';

interface SectionHeaderFormItemProps {
  title: React.ReactNode;
  style?: CSSProperties;
}

class SectionHeaderFormItem extends React.Component<SectionHeaderFormItemProps, {}> {

  public render(): React.ReactNode {
    const {title, children, style} = this.props;
    return (
      <FormItem style={{marginBottom: 16, marginTop: -8, ...style}}>
        <div className="ant-col ant-form-item-label ant-col-xs-24 ant-col-sm-8"/>
        <div className="ant-col ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-16">
          <h3 style={{marginBottom: 0}}>{title}</h3>
          {children}
        </div>
      </FormItem>
    );
  }

}

export default SectionHeaderFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/SectionHeaderFormItem.tsx